<template>
    <div>
        <el-menu :default-active="activeIndex"
                 style="font-weight: 400"
                 text-color="#8590a6"
                 active-text-color="#121212"
                 mode="horizontal"
                 @select="menuSelect">
            <el-menu-item index="Home">首页</el-menu-item>
            <el-menu-item @click="toBlog">文档</el-menu-item>
            <el-menu-item index="DataList" v-if="isLogin">个人风暴</el-menu-item>
            <el-menu-item index="DataListOpen">公共风暴</el-menu-item>
            <el-menu-item index="EventToolExample">体验区</el-menu-item>
            <!--            <el-menu-item @click="toGitee" style="color: red;font-weight: bold">-->
            <!--                开源-->
            <!--            </el-menu-item>-->

            <div class="login">
                <template v-if="isLogin">
                    <div class="user">
                        <ul class="nav">
                            <li class="drop-down">
                                <a href="javascript:;" style="padding-right: 15px;">
                                    {{baseInfo.userName}}
                                    <img class="user-sel" width="30px" src="@/assets/user.png"/>
                                </a>
                                <ul class="drop-down-content">
                                    <li class="drop-down-item">
                                        <a class="logout" @click="logout" target="_self">退出</a>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </template>
                <template v-else>
                    <div class="loginbtn">
                        <el-button round @click="signin">登录</el-button>
                        <el-button round @click="signup">注册</el-button>
                    </div>
                </template>
            </div>
        </el-menu>
    </div>
</template>

<script>
import {mapState} from "vuex";
import tokenService from "../service/tokenService";
import api from "../common/api";
import request from "../common/request";
import store from "../store/store";
import utils from "../common/utils";

export default {
    name: "Header",
    data: function () {
        return {
            activeIndex: 'Home',
        }
    },
    created() {
        this.activeIndex = this.$route.name
    },
    computed: {
        ...mapState([
            "baseInfo"
        ]),
        isLogin: function () {
            //检查token是否有效
            let curToken = tokenService.getToken();
            return tokenService.isTokenValid(curToken)
        }
    },
    methods: {
        menuSelect: function (name, name2) {
            if (name != null && this.$route.name !== name) {
                this.$router.push({name: name})
            }
        },
        initMenu: function (name) {
            this.activeIndex = name
        },
        signup: function () {
            this.$router.push({name: "Signup"})
        },
        signin: function () {
            this.$router.push({name: "Signin"})
        },
        //退出登陆
        logout: function () {
            store.commit("setBaseInfo", {userId: '', userName: ''});
            store.commit("setToken", '');
            localStorage.removeItem(api.TOKEN_NAME)

            this.$router.push({name: "Home"})
        },
        toBlog: function () {
            window.open("http://docs.eventstorming.net.cn/docs/node")
        },
        // toGitee: function () {
        //     window.open("https://gitee.com/xinnianq")
        // },
    },
    watch: {
        $route(to) {
            this.initMenu(to.name)
        },
    }
}
</script>

<style lang="scss" scoped>
.el-menu {
    li {
        a {
            display: block;
            width: 100%;
            height: 60px;
            text-decoration: none !important;
        }
    }
}


.login {
    position: absolute;
    right: 0;
    height: 60px;

    .loginbtn {
        height: 60px;
        line-height: 60px;
        padding-right: 15px;
    }
}

.user {
    float: right;

    ul {
        list-style: none;
    }

    .nav {
        margin: 0px;
        padding: 0px;
        float: left;

        .drop-down {
            min-width: 100%;
            position: relative;

            & > a {
                display: flex;
                align-items: center;
                font-size: 14px;
                text-decoration: none;
            }

            &:hover .drop-down-content {
                height: auto;
                color: rgb(133, 144, 166);
            }

            a {
                white-space: nowrap;
                color: rgb(133, 144, 166);
            }


            .user-sel {
                margin: auto 0px auto 10px;
            }

            .drop-down-content {
                height: auto;
                color: rgb(133, 144, 166);
                background-color: #ffffff;
                border-bottom-left-radius: 2px;
                border-bottom-right-radius: 2px;
                min-width: 100%;
                padding: 0;
                height: 0;
                overflow: hidden;
                position: absolute;
                transition: all 0.1s ease;
                text-align: center;
                z-index: 99;

                .logout {
                    display: block;
                }

                a {
                    text-decoration: none;
                    text-align: center;
                    line-height: 44px;
                    font-size: 14px;
                    height: 44px;
                }

                .drop-down-item {
                    cursor: pointer;

                    a {
                        &:hover {
                            background-color: #ffffff;
                            color: rgb(133, 144, 166);
                        }
                    }
                }
            }
        }
    }
}
</style>
